import DoodleBodyCorps1 from './corps-1';
import DoodleBodyCorps2 from './corps-2';
import DoodleBodyCorps3 from './corps-3';
import DoodleBodyCorps4 from './corps-4';
import DoodleBodyCorps5 from './corps-5';

export {
	DoodleBodyCorps1,
	DoodleBodyCorps2,
	DoodleBodyCorps3,
	DoodleBodyCorps4,
	DoodleBodyCorps5
};

// keys are saved in doodle configurations: never rename or remove one
export const DoodleBodyParts = {
	'corps-1': DoodleBodyCorps1,
	'corps-2': DoodleBodyCorps2,
	'corps-3': DoodleBodyCorps3,
	'corps-4': DoodleBodyCorps4,
	'corps-5': DoodleBodyCorps5
};

export type DoodleBodyKey = keyof typeof DoodleBodyParts;
